import { Col, Container, Row, Spinner } from "react-bootstrap";
import Header from "../../components/header"
import { BackButtonSignUp, ContainerSignUp, ContainerSignUpButtons, NextButtonSignUp, StyledInputSignUp, StyledSignUpText } from "../../components/renderField/styles";
import { CardEmployee } from "../welcome/styles";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { StyledBackButton, StyledContainerButtons, StyledContainerLine, StyledContainerParagraph, StyledLoginButton, StyledParagraph, StyledSwitchButton } from "../signup/styles";
import { useToast } from "../../context/Toast";
import 'react-phone-number-input/style.css'
import ptBr from 'react-phone-number-input/locale/pt-BR.json'
import { StyledInputEmployee } from "./inputStyle";
import { startCellphoneAuth } from "../../services/user/user";



import { useTranslation } from 'react-i18next';
const CellphoneAuth : React.FC = () =>{
    const { t } = useTranslation('auth');

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [loadingButton, setLoadingButton] = useState(false)
    const {showToast} = useToast()
    const [phone, setPhone] = useState<any>(''); // Tipando o useState para string
    const [error, setError] = useState<string>(''); // Tipando o erro também como string

    // Função para validar o número de telefone
    // const validatePhoneNumber = (): string | null => {
    //     if (!phone) {
    //         showToast('Você precisa informar um número de telefone', 'error')
    //         return null;
    //     }
        
    //     //adiciona o "+" ao DDI
    //     const formattedPhone = phone;
        

    //     return formattedPhone; //retorna o número formatado
    // };

    const checkCellphone = (cellphone: string): boolean => {
        // Regex para validar números de celular brasileiros e internacionais
        const regex = /^(?:\+55\s?)?(?:\(?(\d{2})\)?[\s-]?)?9\d{4}[-\s]?\d{4}$|^(?:\+\d{1,3}\s?)?(?:\(?\d{1,3}\)?[\s-]?)?\d{4}[-\s]?\d{4}$/;
    
        return regex.test(cellphone);
    }
    

    // Função chamada no envio do formulário
    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>): Promise<void> => {
        e.preventDefault();
        setLoadingButton(true);
        // const formattedPhone = validatePhoneNumber();
        
        if (phone && checkCellphone(phone)) {
            // showToast(`Foi enviado um código no seu celular por SMS para o celular ${phone} `, 'success', 6000)

            try {
                const authData = await startCellphoneAuth(phone);
                if (authData?.challengeName !== 'SMS_OTP' || typeof authData?.session !== 'string' || !authData.session) {
                    showToast(t('errors.smsStart'), 'error', 8000);
                    return;
                }

                showToast(t('verification.sent'), 'success', 6000);
                navigate('/confirmation-code-auth', { state: { cellphone: phone, session: authData.session } });

            } catch (error: any) {
                setLoadingButton(false);
                if(error?.response?.status === 400) {
                    showToast(t('validation.phoneInvalid'), 'error', 6000);
                } else if(error?.response?.status === 404) {
                    showToast(t('errors.phoneNotFound'), 'error', 8000);
                } else if(error?.response?.status === 403) {
                    showToast(t('errors.phoneUnauthorized'), 'info', 10000);
                } else {
                    showToast(t('errors.generic'), 'error', 30000)
                }
            }
            
            setLoadingButton(false);
            // navigate('/confirmation-code-auth')

        } else {
            showToast(t('validation.phoneInvalid'), 'error', 6000);
            setLoadingButton(false);
            
        }        
    };
    

   
    return(
        <>
            <Header />
            <Container fluid className="d-flex h-100 mt-5 mb-2">
                <Row className="justify-content-center align-self-center w-100">
                    <Col md={9} lg={7}>
                        <CardEmployee>
                            {loading ? (
                                <div className="d-flex align-items-center justify-content-center" style={{
                                    minHeight: '300px',

                                }}>
                                    <Spinner style={{ color: '#c9c9c9' }}></Spinner>
                                </div>
                            ) : (
                                <ContainerSignUp>
                                    <div className="d-flex justify-content-center flex-column ">
                                        <StyledSignUpText>{t('signIn.phonePrompt')}</StyledSignUpText>
                                        <div className="d-flex justify-content-center" 
                                            style={{
                                                width: '100%',
                                                flexDirection: 'column',
                                            }}>
                                        
                                            {/* <PhoneNumberInput phone={phone} setPhone={setPhone} /> */}
                                            {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}

                                            <StyledInputEmployee
                                                placeholder={t('signIn.phonePlaceholder')}
                                                value={phone}
                                                onChange={setPhone}
                                                limitMaxLength={true}
                                                labels={ptBr}  
                                                defaultCountry="BR"                         
                                            />

                                        </div>
                                    </div>
                                    <StyledContainerParagraph>
                                        <StyledContainerLine></StyledContainerLine>
                                        <StyledParagraph>ou</StyledParagraph>
                                        <StyledContainerLine></StyledContainerLine>
                                    </StyledContainerParagraph>

                                    <StyledSwitchButton onClick={() => navigate('/signup')}>{t('signIn.switchToEmail')}</StyledSwitchButton>
                                    <ContainerSignUpButtons>
                                        <StyledContainerButtons>
                                            <StyledBackButton onClick={() => { navigate('/signup') }} >{t('signIn.back')}</StyledBackButton>
                                            
                                            <StyledLoginButton disabled={loadingButton} onClick={handleSubmit}>
                                                {loadingButton ? (
                                                        <Spinner style={{ height: "18px", width: "18px", marginRight: "12px", color: '#191919' }}></Spinner>
                                                ) : (<></>)}
                                                {t('signIn.submit')}
                                            </StyledLoginButton>
                                        </StyledContainerButtons>
                                        
                                    </ContainerSignUpButtons>
                                </ContainerSignUp>
                            )}
                        </CardEmployee>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default CellphoneAuth;
